import {
  login, logout, emailOtp, resendSms, postOtp, postDetails, viewAsAdmin,
  fetchEmails, addEmail, changeAddEmail, deleteEmail, makeDefault,
  sendVerification, primaryEmailConfirmed, showResend
} from './login-actions'

export {
  login,
  logout,
  emailOtp,
  resendSms,
  postOtp,
  postDetails,
  viewAsAdmin,
  fetchEmails,
  addEmail,
  changeAddEmail,
  deleteEmail,
  makeDefault,
  sendVerification,
  primaryEmailConfirmed,
  showResend
}



// WEBPACK FOOTER //
// ./src/app/actions/index.js